export default "__VITE_ASSET__zDHpkVxu__ 500w";